angular.module('jv.getDeferred', [])
	.provider('getDeferred', function() {
		var _cacheTime = 300; // default

		this.setCacheTime = function(cacheTime) {
			if(0 < cacheTime && cacheTime < Infinity){
				_cacheTime = cacheTime;
			}
			return _cacheTime;
		};

		this.$get = ['$cacheFactory', '$q', '$timeout', function($cacheFactory, $q, $timeout) {
			var cache = $cacheFactory('DeferredServiceCache');
			return function(nameOfService, cacheTime) {
				var _theService = cache.get(nameOfService);
				if(angular.isDefined(_theService)) {
					return _theService;
				}

				var localCacheTime = cacheTime || _cacheTime;
				var deferred = $q.defer();

				cache.put(nameOfService, deferred);
				$timeout(function() {
					cache.remove(nameOfService);
				}, localCacheTime);

				return deferred;

			};
		}];
	});